import { Sprite, Texture, Container } from 'pixi.js'
import ScrollBar from './ScrollBar.js'

const { WHITE } = Texture

// TODO only support vertical
export default class ScrollView extends Container {
  direction = 'vertical' // horizontal
  padding = {
    top: 15,
    right: 15,
    bottom: 15,
    left: 15,
  }
  spaceX = 15
  spaceY = 15

  constructor() {
    super()
    this.scroller = new ScrollBar()
    this.content = new Container()

    this.view = new Container()
    this.view.interactive = true
    this.view.on('touchstart', this.handleTouchStart, this)
    const mask = new Sprite(WHITE)
    this.view.mask = mask
    this.view.addChild(mask, this.content)

    this.addChild(this.view, this.scroller)
  }

  clearItems() {
    this.content.removeChildren()
  }

  addItems(items) {
    const { top, left } = this.padding
    const { spaceY } = this
    const pos = { x: left, y: top }
    // TODO 只处理了单列竖排的情况
    items.forEach(item => {
      item.position.copy(pos)
      pos.y += item.height + spaceY
      this.content.addChild(item)
    })
  }

  // call after addItems
  setSize(w, h) {
    this.view.mask.width = w
    this.view.mask.height = h

    // TODO only support one direction
    if (this.direction === 'vertical') {
      this.scroller.updateParams({
        // FIXME 数值计算不对, 暂时加些
        len: this.content.height + 30,
        visibleLen: h,
        setter: v => (this.content.y = v),
        getter: () => this.content.y,
      })
      this.scroller.x = w - this.scroller.width
    } else {
      this.scroller.updateParams({
        // FIXME 数值计算不对, 暂时加些
        len: this.content.width + 30,
        visibleLen: w,
        setter: v => (this.content.x = v),
        getter: () => this.content.x,
      })
      this.scroller.y = h + this.scroller.width + 5
    }
  }

  handleTouchStart = evt => {
    this.isScrolling = true

    const p = evt.data.getLocalPosition(this.view)
    this.scroller.handleStart(
      this.direction === 'vertical' ? p.y : p.x,
      evt.data.originalEvent.timeStamp
    )

    this.view.on('touchmove', this.handleTouchMove, this)
    this.view.on('touchend', this.handleTouchEnd, this)
    this.view.on('touchcancel', this.handleTouchEnd, this)
    this.view.on('touchendoutside', this.handleTouchEnd, this)
  }

  handleTouchMove = evt => {
    if (!this.isScrolling) return

    const p = evt.data.getLocalPosition(this.view)
    this.scroller.handleMove(
      this.direction === 'vertical' ? p.y : p.x,
      evt.data.originalEvent.timeStamp
    )
  }

  handleTouchEnd = () => {
    this.isScrolling = false
    this.scroller.handleEnd()

    this.view.off('touchmove', this.handleTouchMove, this)
    this.view.off('touchend', this.handleTouchEnd, this)
    this.view.off('touchcancel', this.handleTouchEnd, this)
    this.view.off('touchendoutside', this.handleTouchEnd, this)
  }
}
